var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/use-get-widget-container.hook.ts
import { useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Auth } from "@leagueplatform/auth";

// src/utils/get-observability-context.ts
var getObservabilityContext = (context) => __spreadProps(__spreadValues({}, context), {
  tags: __spreadValues({
    dependentModule: "masonry",
    supportTeam: "masonry-web"
  }, context == null ? void 0 : context.tags)
});

// src/utils/get-widget-container.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_CONTAINER = "get_widget_container";
var getWidgetContainer = (appId, version, apiParams, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch.fetch(
    {
      message_type: GET_WIDGET_CONTAINER,
      info: __spreadValues({
        type: appId,
        version
      }, apiParams && { api_params: apiParams })
    },
    {
      errorContext
    },
    { containerId: appId }
  );
});

// src/hooks/use-get-widget-container.hook.ts
var GET_WIDGET_CONTAINER2 = "get_widget_container";
var useGetWidgetContainer = (appId, version, apiParams, errorContext = {}) => {
  const queryClient = useQueryClient();
  useEffect(
    () => () => {
      setTimeout(() => {
        Auth.isAuthorized().then((isAuthorized) => {
          if (isAuthorized) {
            queryClient.refetchQueries([GET_WIDGET_CONTAINER2, appId, version]);
          }
        });
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery(
    [GET_WIDGET_CONTAINER2, appId, version],
    () => getWidgetContainer(
      appId,
      version,
      apiParams,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget container api error",
        tags: __spreadValues({
          container: appId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    )
  );
};

// src/hooks/use-get-widget-data.hook.ts
import { useEffect as useEffect2 } from "react";
import { useQuery as useQuery2, useQueryClient as useQueryClient2 } from "@tanstack/react-query";

// src/utils/get-widget-data.ts
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
var GET_WIDGET_DATA = "get_widget_data";
var getWidgetData = (params, version, widgetId, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch2.fetch(
    {
      message_type: GET_WIDGET_DATA,
      info: __spreadProps(__spreadValues({}, params), {
        version
      })
    },
    {
      errorContext
    },
    { widgetId }
  );
});

// src/utils/normalize-paramters.ts
var normalizeParams = ({
  params = []
}) => params.reduce(
  (paramObj, { key, value }) => __spreadProps(__spreadValues({}, paramObj), { [key]: value }),
  {}
);

// src/hooks/use-get-widget-data.hook.ts
import { Auth as Auth2 } from "@leagueplatform/auth";
var GET_WIDGET_DATA2 = "get_widget_data";
var useGetWidgetData = (widget, version, errorContext = {}) => {
  const { id: widgetId, links } = widget;
  const queryClient = useQueryClient2();
  const linkDetails = links.find(({ rel }) => rel === "data");
  useEffect2(
    () => () => {
      setTimeout(() => {
        Auth2.isAuthorized().then((isAuthorized) => {
          if (isAuthorized) {
            queryClient.refetchQueries([GET_WIDGET_DATA2, widgetId, version]);
          }
        });
      }, 500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return useQuery2(
    [GET_WIDGET_DATA2, widgetId, version],
    () => getWidgetData(
      normalizeParams({ params: linkDetails == null ? void 0 : linkDetails.params }),
      version,
      widgetId,
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - get widget data api error",
        tags: __spreadValues({
          widgetId,
          apiVersion: version
        }, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    {
      onSuccess: (data) => {
        if (!(data == null ? void 0 : data.attributes)) {
          console.warn(
            `[Masonry]: No attributes returned from api get_widget_data for widget id %c'${data.id}'`
          );
        }
      }
    }
  );
};

// src/hooks/use-post-dismiss-widget.hook.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";

// src/utils/post-widget-dismiss.ts
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
var postWidgetDismiss = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch3.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-post-dismiss-widget.hook.ts
var usePostDismissWidget = (dismissed, link, errorContext = {}) => {
  const { href = "", params } = link || {};
  useQuery3(
    [href],
    () => postWidgetDismiss(
      href,
      normalizeParams({ params }),
      getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
        errorName: "Masonry - post dismiss widget api error",
        tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
      }))
    ),
    { enabled: dismissed }
  );
};

// src/hooks/use-generate-pdf-report.hook.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";

// src/utils/get-container-pdf.ts
import { SocketAsFetch as SocketAsFetch4 } from "@leagueplatform/socket-as-fetch";
var getContainerPDF = (messageType, params, errorContext) => __async(void 0, null, function* () {
  return SocketAsFetch4.fetch(
    {
      message_type: messageType,
      info: __spreadValues({}, params)
    },
    {
      errorContext
    }
  );
});

// src/hooks/use-generate-pdf-report.hook.ts
var GET_CONTAINER_PDF = "get_container_pdf";
var useGeneratePDFReport = (generatePDF, {
  containerId: container_id,
  filename,
  templateId: template_id,
  version
}, errorContext = {}) => useQuery4(
  [GET_CONTAINER_PDF],
  () => getContainerPDF(
    GET_CONTAINER_PDF,
    __spreadValues({
      container_id,
      filename,
      version
    }, template_id && { template_id }),
    getObservabilityContext(__spreadProps(__spreadValues({}, errorContext), {
      errorName: "Masonry - get container pdf widget api error",
      tags: __spreadValues({}, (errorContext == null ? void 0 : errorContext.tags) || {})
    }))
  ),
  { enabled: generatePDF }
);

// src/hooks/use-invalidate-get-container-request.hook.ts
import { useCallback } from "react";
import { useQueryClient as useQueryClient3 } from "@tanstack/react-query";
var useInvalidateContainerRequest = (appId, version) => {
  const queryClient = useQueryClient3();
  return useCallback(() => {
    queryClient.invalidateQueries([GET_WIDGET_CONTAINER2, appId, version]);
  }, [appId, version, queryClient]);
};

// src/types/widget-data.ts
var Orientation = /* @__PURE__ */ ((Orientation2) => {
  Orientation2["VERTICAL"] = "vertical";
  Orientation2["HORIZONTAL"] = "horizontal";
  Orientation2["GRID"] = "grid";
  return Orientation2;
})(Orientation || {});
var SupportedMedia = /* @__PURE__ */ ((SupportedMedia2) => {
  SupportedMedia2["MOBILE"] = "mobile";
  SupportedMedia2["TABLET"] = "tablet";
  SupportedMedia2["LAPTOP"] = "laptop";
  SupportedMedia2["DESKTOP"] = "desktop";
  return SupportedMedia2;
})(SupportedMedia || {});

// src/types/widget-types.ts
var WidgetType = /* @__PURE__ */ ((WidgetType2) => {
  WidgetType2["SMALL_VISUAL_CARD"] = "text_with_small_image";
  WidgetType2["LARGE_VISUAL_CARD"] = "text_with_large_image";
  WidgetType2["TEXT_WITH_CTA_CARD"] = "text_with_button";
  WidgetType2["CAROUSEL"] = "carousel";
  WidgetType2["HEALTH_JOURNEY"] = "health_journey";
  WidgetType2["WELCOME_BANNER"] = "welcome_banner";
  WidgetType2["HERO_BANNER"] = "heroBanner";
  WidgetType2["PRODUCT_CAROUSEL"] = "product_carousel";
  WidgetType2["NOTIFICATION_BANNER"] = "notification_banner";
  WidgetType2["NOTIFICATION_CARD"] = "notification_card";
  WidgetType2["XS_VISUAL_CARD"] = "xs_visual_card";
  WidgetType2["VERTICAL_STACK_XS"] = "vertical_stack_xs";
  WidgetType2["IMAGE_FOOTER"] = "image_footer";
  WidgetType2["CUSTOM_COMPONENT"] = "custom_component";
  WidgetType2["PROGRESS_BAR"] = "progress_bar";
  WidgetType2["PROGRESS_RING"] = "progress_ring";
  WidgetType2["TWO_UP_CARD"] = "2_up_card";
  WidgetType2["SECTION_HEADER"] = "section_header";
  WidgetType2["STACK"] = "stack";
  WidgetType2["GENERIC_CAROUSEL"] = "genericCarousel";
  WidgetType2["METRIC_CARD"] = "metricCard";
  WidgetType2["HIDDEN"] = "hidden";
  return WidgetType2;
})(WidgetType || {});

// src/__mocks__/get-widget-container.mocks.ts
var getWidgetContainerMock = {
  type: "b2b_care_homepage",
  widgets: [
    {
      id: "6739f94fca803fd3fb6db4b11db7302a",
      type: "section_header" /* SECTION_HEADER */,
      name: "How can we help you",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "6739f94fca803fd3fb6db4b11db7302a"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "821ab100fcb5605d683fff1779a017a8",
      type: "text_with_large_image" /* LARGE_VISUAL_CARD */,
      name: "how can we help Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "821ab100fcb5605d683fff1779a017a8"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "04e87b5f290fd3063af7c5c5af5b4e00",
      type: "stack" /* STACK */,
      name: "Care Providers List",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "04e87b5f290fd3063af7c5c5af5b4e00"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "e5a5bc5ebb5cd237e425efdc9dcf4a1f",
      type: "carousel" /* CAROUSEL */,
      name: "Recommended QuickActions Menu Items",
      group_id: "",
      module: "default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "e5a5bc5ebb5cd237e425efdc9dcf4a1f"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/types/loader-types.ts
var LoaderType = /* @__PURE__ */ ((LoaderType2) => {
  LoaderType2["SMALL"] = "loadingSmall";
  LoaderType2["LARGE"] = "loadingLarge";
  LoaderType2["EXTRA_SMALL"] = "loadingExtraSmall";
  LoaderType2["HERO_BANNER"] = "loadingHeroBanner";
  return LoaderType2;
})(LoaderType || {});

// src/__mocks__/get-widget-container-v2.mocks.ts
var getWidgetContainerV2Mock = {
  type: "homescreen",
  widgets: [
    {
      id: "current_default",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_default_with_loading",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_default_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    {
      id: "current_custom_component",
      custom_type: "health_journey",
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 4. (NEW) Current custom component with loading
    {
      id: "current_custom_component_with_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "current_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 5. (NEW) Custom component without loading
    {
      id: "new_custom_component_without_loading",
      // custom_type: 'health_journey',
      module: "health_journey",
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_without_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    },
    // 6. (NEW) Custom component with loading
    {
      id: "new_custom_component_with_loading",
      module: "health_journey",
      // custom_type: 'health_journey',
      loading: {
        type: "loadingSmall" /* SMALL */,
        traits: {}
      },
      links: [
        {
          rel: "data",
          type: "GET",
          href: "get_widget_data",
          params: [
            {
              key: "widget_id",
              value: "new_custom_component_with_loading"
            },
            {
              key: "version",
              value: "1"
            }
          ],
          protocol: "websocket"
        }
      ]
    }
  ]
};

// src/__mocks__/get-masonry-node-forms.ts
import { EVENT_NAME } from "@leagueplatform/analytics";
var mockMasonryFormsNode = {
  data: {
    attributes: {
      node: {
        locatorId: "core$demo-form$root",
        namespace: "default",
        type: "verticalLayout",
        properties: {
          isSemanticList: false
        },
        actions: {
          onLoad: {
            analytics: {
              event_name: EVENT_NAME.SCREEN_LOADED,
              payload: {
                detail: "a demo form",
                impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                node: {
                  id: "core$demo-form$root",
                  label: "Demo form v2 root node",
                  type: "verticalLayout"
                },
                product_area: "masonry",
                screen_name: "demo-form",
                sub_product_area: "forms"
              }
            },
            namespace: "default",
            payload: {},
            type: "onLoad"
          }
        }
      }
    },
    id: "core$demo-form$root",
    relationships: {
      sections: {
        data: [
          {
            id: "core$demo-form$root-section-items",
            type: "node-section"
          }
        ]
      }
    },
    type: "node-data"
  },
  included: [
    {
      attributes: {
        name: "items"
      },
      id: "core$demo-form$root-section-items",
      relationships: {
        nodes: {
          data: [
            {
              id: "core$demo-form$demoFormHeader",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormWrapper",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormFooter",
              type: "node-data"
            }
          ]
        }
      },
      type: "node-section"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormHeader",
          namespace: "default",
          type: "heroBanner",
          properties: {
            body: "Spen",
            buttonLabel: "Click Me",
            curved: false,
            eyebrow: "Eyebrow text",
            heading: "Welcome, this is a heroBanner!",
            includeSafeArea: false
          },
          actions: {
            onButtonClick: {
              analytics: {
                event_name: EVENT_NAME.BUTTON_CLICKED,
                payload: {
                  detail: "header",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormHeader",
                    label: "Hero Banner",
                    parent_label: "Demo form v2 root node",
                    parent_type: "verticalLayout",
                    type: "heroBanner"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {
                url: "https://www.league.com/ca"
              },
              type: "deeplink"
            },
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: "header",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormHeader",
                    label: "Hero Banner",
                    parent_label: "Demo form v2 root node",
                    parent_type: "verticalLayout",
                    type: "heroBanner"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormHeader",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormHeader?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormWrapper",
          namespace: "default",
          type: "form",
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: "a demo form wrapper rendered",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormWrapper",
                    label: "Form Wrapper",
                    parent_label: "Demo form v2 root node",
                    parent_type: "verticalLayout",
                    type: "form"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "forms"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormWrapper",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormWrapper?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      relationships: {
        sections: {
          data: [
            {
              id: "core$demo-form$demoFormWrapper-section-layout",
              type: "node-section"
            }
          ]
        }
      },
      type: "node-data"
    },
    {
      attributes: {
        name: "layout"
      },
      id: "core$demo-form$demoFormWrapper-section-layout",
      relationships: {
        nodes: {
          data: [
            {
              id: "core$demo-form$demoFormFieldsVerticalLayout",
              type: "node-data"
            }
          ]
        }
      },
      type: "node-section"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormFieldsVerticalLayout",
          namespace: "default",
          type: "verticalLayout",
          properties: {
            isSemanticList: false
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: "a demo form",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormFieldsVerticalLayout",
                    label: "Form fields vertical layout",
                    parent_label: "Form Wrapper",
                    parent_type: "form",
                    type: "verticalLayout"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "forms"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormFieldsVerticalLayout",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormFieldsVerticalLayout?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      relationships: {
        sections: {
          data: [
            {
              id: "core$demo-form$demoFormFieldsVerticalLayout-section-items",
              type: "node-section"
            }
          ]
        }
      },
      type: "node-data"
    },
    {
      attributes: {
        name: "items"
      },
      id: "core$demo-form$demoFormFieldsVerticalLayout-section-items",
      relationships: {
        nodes: {
          data: [
            {
              id: "core$demo-form$demoFormTextInputRequired",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputOptional",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputMoney",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputEmail",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputPassword",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputTelephone",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputDatePicker",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormTextInputReadonly",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormSelectInput",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormSelectInputGrouped",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormRadioGroupInline",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormRadioGroupRow",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormRadioGroupRowDisabled",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormCheckboxGroupInline",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormCheckboxGroupRow",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormCheckboxGroupRowOptional",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormCheckboxGroupRowDisabled",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormConditionalStack",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormSelectInputDataProcessorBehavior",
              type: "node-data"
            },
            {
              id: "core$demo-form$demoFormSubmitButton",
              type: "node-data"
            }
          ]
        }
      },
      type: "node-section"
    },
    {
      attributes: {
        node: {
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputRequired",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "Text input hint",
              label: "First name",
              showOptionalFlag: false,
              tooltipContent: "Tooltip content",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "tooltip label",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "web",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Enter your first name!",
            value: "Spen"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "text input",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputRequired",
                    label: "textInputRequired",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputRequired",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputRequired?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputOptional",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputOptional",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "Text input hint",
              label: "Last Name",
              showOptionalFlag: true,
              tooltipContent: "Tooltip content",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "tooltip label"
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Enter your last name!"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "last name",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputOptional",
                    label: "textInputOptional",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputOptional",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputOptional?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputMoney",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputMoney",
              formFieldType: "number",
              formId: "demo-form",
              hideLabel: false,
              label: "Salary",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            leadingAddon: {
              type: "icon",
              value: "descriptiveMoneyBill"
            },
            leadingContent: {
              type: "text",
              value: "$"
            },
            maxLines: 1,
            placeholder: "Enter your salary!",
            value: "30000"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "salary input",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputMoney",
                    label: "textInputMoney",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputMoney",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputMoney?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputEmail",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputEmail",
              formFieldType: "email",
              formId: "demo-form",
              hideLabel: false,
              label: "Email",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                },
                {
                  payload: {
                    pattern: "^[^@]+@[^@]+\\.[^@]+$"
                  },
                  statusMessage: "The email is invalid",
                  statusType: "error",
                  validationType: "pattern"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Enter your email!"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "salary input",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputEmail",
                    label: "textInputEmail",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputEmail",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputEmail?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputPassword",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputPassword",
              formFieldType: "password",
              formId: "demo-form",
              hideLabel: false,
              hint: "It should have one of uppercase, lowercase, digit and special symbol. And should be more than 4 character",
              label: "Password field",
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                },
                {
                  payload: {
                    pattern: "[A-Z]+"
                  },
                  statusMessage: "This password should have atleast 1 uppercase character",
                  statusType: "error",
                  validationType: "pattern"
                },
                {
                  payload: {
                    pattern: "[a-z]+"
                  },
                  statusMessage: "This password should have atleast 1 lowercase character",
                  statusType: "error",
                  validationType: "pattern"
                },
                {
                  payload: {
                    pattern: "[0-9]+"
                  },
                  statusMessage: "This password should have atleast 1 digit",
                  statusType: "error",
                  validationType: "pattern"
                },
                {
                  payload: {
                    pattern: "[^a-zA-Z0-9]+"
                  },
                  statusMessage: "This password should have atleast 1 special character",
                  statusType: "error",
                  validationType: "pattern"
                },
                {
                  payload: {
                    minLength: 5
                  },
                  statusMessage: "This password should be atleast 5 characters long",
                  statusType: "error",
                  validationType: "minLength"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "text input password",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputPassword",
                    label: "textInputPassword",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputPassword",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputPassword?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputTelephone",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputTelephone",
              formFieldType: "tel",
              formId: "demo-form",
              hideLabel: false,
              hint: "Enter a phone number along with area code",
              label: "Telephone field",
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                },
                {
                  payload: {
                    pattern: "^(\\+\\d{1,2}\\s)?\\(?\\d{3}\\)?[\\s.-]\\d{3}[\\s.-]\\d{4}$"
                  },
                  statusMessage: "This is not a valid telephone number. Expected format: +1 (123) 123-1234 or 123-123-1234 or 123 123 1234",
                  statusType: "error",
                  validationType: "pattern"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "text input telephone",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputTelephone",
                    label: "textInputTelephone",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputTelephone",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputTelephone?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputDatePicker",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputDatePicker",
              formFieldType: "date",
              formId: "demo-form",
              hideLabel: false,
              hint: "This is a Datepicker",
              label: "A date picker",
              showOptionalFlag: false,
              tooltipContent: "this is textInput's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is textInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "text input date picker",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputDatePicker",
                    label: "textInputDatePicker",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputDatePicker",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputDatePicker?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormTextInputReadonly",
          namespace: "default",
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "textInputReadonly",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              label: "Readonly field",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            readOnly: true,
            value: "I am readonly"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "text input readonly",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormTextInputReadonly",
                    label: "textInputReadonly",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormTextInputReadonly",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormTextInputReadonly?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormSelectInput",
          namespace: "default",
          type: "selectInput",
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: "selectInput",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is selectInput's hint",
              label: "Sample selectInput",
              showOptionalFlag: false,
              tooltipContent: "this is selectInput's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is selectInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            options: [
              {
                disabled: false,
                label: "A",
                options: null,
                value: "optionA"
              },
              {
                disabled: false,
                label: "B",
                options: null,
                value: "optionB"
              },
              {
                disabled: true,
                label: "Disabled option",
                options: null,
                value: "disabled"
              }
            ],
            value: "optionB"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "select input",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormSelectInput",
                    label: "selectInput",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "selectInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormSelectInput",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormSelectInput?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormSelectInputGrouped",
          namespace: "default",
          type: "selectInput",
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: "selectInput",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is selectInput's hint",
              label: "Sample selectInput",
              showOptionalFlag: false,
              tooltipContent: "this is selectInput's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is selectInput's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            options: [
              {
                disabled: false,
                label: "Group A",
                options: [
                  {
                    disabled: false,
                    label: "A1",
                    value: "optionA1"
                  },
                  {
                    disabled: false,
                    label: "A2",
                    value: "optionA2"
                  },
                  {
                    disabled: true,
                    label: "Disabled option A",
                    value: "disabled"
                  }
                ],
                value: null
              },
              {
                disabled: false,
                label: "B",
                options: [
                  {
                    disabled: false,
                    label: "B1",
                    value: "optionB1"
                  },
                  {
                    disabled: false,
                    label: "B2",
                    value: "optionB2"
                  }
                ],
                value: null
              },
              {
                disabled: true,
                label: "Disabled group",
                options: [
                  {
                    disabled: false,
                    label: "D1",
                    value: "optionD1"
                  },
                  {
                    disabled: true,
                    label: "D2",
                    value: "optionD2"
                  }
                ],
                value: "disabled"
              }
            ],
            value: "optionB2"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "select input",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormSelectInputGrouped",
                    label: "selectInputGrouped",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "selectInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormSelectInputGrouped",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormSelectInputGrouped?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormRadioGroupInline",
          namespace: "default",
          type: "radioGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "radioGroupInline",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: "Sample radioGroup",
              showOptionalFlag: false,
              tooltipContent: "this is radioGroup's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is radioGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            layout: "inline",
            options: [
              {
                disabled: null,
                hint: "Select this forOption A",
                label: "A",
                value: "optionA"
              },
              {
                disabled: null,
                hint: "Select this forOption B",
                label: "B",
                value: "optionB"
              },
              {
                disabled: null,
                hint: "Select this forOption C",
                label: "C",
                value: "optionC"
              }
            ],
            value: "optionB"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "radio group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormRadioGroupInline",
                    label: "radioGroupInline",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "radioGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormRadioGroupInline",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormRadioGroupInline?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormRadioGroupRow",
          namespace: "default",
          type: "radioGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "radioGroupRow",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: "Sample radioGroup",
              showOptionalFlag: false,
              tooltipContent: "this is radioGroup's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is radioGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            layout: "row",
            options: [
              {
                disabled: null,
                hint: "Select this forOption A",
                label: "Option A",
                value: "optionA"
              },
              {
                disabled: null,
                hint: "Select this forOption B",
                label: "Option B",
                value: "optionB"
              },
              {
                disabled: null,
                hint: "Select this forOption C",
                label: "Option C",
                value: "optionC"
              }
            ],
            value: "optionB"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "radio group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormRadioGroupRow",
                    label: "radioGroupRow",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "radioGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormRadioGroupRow",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormRadioGroupRow?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormRadioGroupRowDisabled",
          namespace: "default",
          type: "radioGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "radioGroupRowDisabled",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is radioGroup's hint",
              label: "Sample radioGroup",
              showOptionalFlag: true
            },
            layout: "row",
            options: [
              {
                disabled: null,
                hint: "Select this forOption A",
                label: "Option A",
                value: "optionA"
              },
              {
                disabled: true,
                hint: "Select this forOption B",
                label: "Option B",
                value: "optionB"
              },
              {
                disabled: null,
                hint: "Select this forOption C",
                label: "Option C",
                value: "optionC"
              }
            ],
            value: "optionB"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "radio group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormRadioGroupRowDisabled",
                    label: "radioGroupRowDisabled",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "radioGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormRadioGroupRowDisabled",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormRadioGroupRowDisabled?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormCheckboxGroupInline",
          namespace: "default",
          type: "checkboxGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "checkboxGroupInline",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: "Sample checkboxGroup",
              showOptionalFlag: false,
              tooltipContent: "this is checkboxGroup's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is checkboxGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            layout: "inline",
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption A",
                label: "Option A",
                readOnly: null,
                value: "optionA"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption B",
                label: "Option B",
                readOnly: null,
                value: "optionB"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption C",
                label: "Option C",
                readOnly: null,
                value: "optionC"
              }
            ],
            value: ["optionB", "optionC"]
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "checkbox group inline",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormCheckboxGroupInline",
                    label: "checkboxGroupInline",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "checkboxGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormCheckboxGroupInline",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormCheckboxGroupInline?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormCheckboxGroupRow",
          namespace: "default",
          type: "checkboxGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "checkboxGroupRow",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: "Sample checkboxGroup",
              showOptionalFlag: false,
              tooltipContent: "this is checkboxGroup's tooltipContent",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "this is checkboxGroup's tooltipLabel",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            layout: "row",
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption A",
                label: "Option A",
                readOnly: null,
                value: "optionA"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption B",
                label: "Option B",
                readOnly: null,
                value: "optionB"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption C",
                label: "Option C",
                readOnly: null,
                value: "optionC"
              },
              {
                disabled: null,
                exclusive: true,
                hint: "Select this for exclusive option",
                label: "Exclusive Option",
                readOnly: null,
                value: "exclusive"
              }
            ],
            value: ["optionB", "optionC"]
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "checkbox group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormCheckboxGroupRow",
                    label: "checkboxGroupRow",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "checkboxGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormCheckboxGroupRow",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRow?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormCheckboxGroupRowOptional",
          namespace: "default",
          type: "checkboxGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "checkboxGroupOptional",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: "Optional Checkbox group",
              showOptionalFlag: true
            },
            layout: "row",
            options: [
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption A",
                label: "Option A",
                readOnly: null,
                value: "optionA"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption B",
                label: "Option B",
                readOnly: null,
                value: "optionB"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption C",
                label: "Option C",
                readOnly: null,
                value: "optionC"
              }
            ],
            value: ["optionB", ""]
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "checkbox group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormCheckboxGroupRowOptional",
                    label: "checkboxGroupOptional",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "checkboxGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormCheckboxGroupRowOptional",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRowOptional?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormCheckboxGroupRowDisabled",
          namespace: "default",
          type: "checkboxGroup",
          properties: {
            formFieldProperties: {
              formFieldId: "checkboxGroupDisabled",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "this is checkboxGroup's hint",
              label: "Disabled Checkbox group",
              showOptionalFlag: true
            },
            layout: "row",
            options: [
              {
                disabled: true,
                exclusive: null,
                hint: "Select this forOption A",
                label: "Option A",
                readOnly: null,
                value: "optionA"
              },
              {
                disabled: true,
                exclusive: null,
                hint: "Select this forOption B",
                label: "Option B",
                readOnly: null,
                value: "optionB"
              },
              {
                disabled: null,
                exclusive: null,
                hint: "Select this forOption C",
                label: "Option C",
                readOnly: null,
                value: "optionC"
              }
            ],
            value: ["optionB", ""]
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "checkbox group row",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormCheckboxGroupRowDisabled",
                    label: "checkboxGroupDisabled",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "checkboxGroup"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormCheckboxGroupRowDisabled",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormCheckboxGroupRowDisabled?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormConditionalStack",
          namespace: "default",
          type: "verticalLayout",
          properties: {
            body: "This is a stack with examples for conditional inputs. Select the payment methods to show/hide the inputs.",
            heading: "Conditional Examples",
            isSemanticList: false
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: "conditional inputs stack",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormConditionalStack",
                    label: "Stack with conditional examples",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "verticalLayout"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "forms"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormConditionalStack",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormConditionalStack?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      relationships: {
        sections: {
          data: [
            {
              id: "core$demo-form$demoFormConditionalStack-section-items",
              type: "node-section"
            }
          ]
        }
      },
      type: "node-data"
    },
    {
      attributes: {
        name: "items"
      },
      id: "core$demo-form$demoFormConditionalStack-section-items",
      relationships: {
        nodes: {
          data: [
            {
              id: "core$demo-form$accountNumber",
              type: "node-data"
            },
            {
              id: "core$demo-form$bankName",
              type: "node-data"
            },
            {
              id: "core$demo-form$cardNumber",
              type: "node-data"
            },
            {
              id: "core$demo-form$paypalEmail",
              type: "node-data"
            },
            {
              id: "core$demo-form$selectPaymentMethod",
              type: "node-data"
            }
          ]
        }
      },
      type: "node-section"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$accountNumber",
          namespace: "default",
          states: {
            isHidden: true
          },
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "accountNumber",
              formFieldType: "number",
              formId: "demo-form",
              hideLabel: false,
              label: "Account Number",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Account Number"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "account number",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$accountNumber",
                    label: "Account number",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$accountNumber",
      links: {
        self: "/v1/masonry-node/core$demo-form$accountNumber?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$bankName",
          namespace: "default",
          states: {
            isHidden: true
          },
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "bankName",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              label: "Bank Name",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Bank Name",
            value: "Pre-filled value"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "bank name",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$bankName",
                    label: "Bank name",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$bankName",
      links: {
        self: "/v1/masonry-node/core$demo-form$bankName?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$cardNumber",
          namespace: "default",
          states: {
            isHidden: true
          },
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "cardNumber",
              formFieldType: "number",
              formId: "demo-form",
              hideLabel: false,
              label: "Card Number",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Card Number!"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "card number",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$cardNumber",
                    label: "Card Number",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$cardNumber",
      links: {
        self: "/v1/masonry-node/core$demo-form$cardNumber?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$paypalEmail",
          namespace: "default",
          states: {
            isHidden: true
          },
          type: "textInput",
          properties: {
            formFieldProperties: {
              formFieldId: "paypalEmail",
              formFieldType: "email",
              formId: "demo-form",
              hideLabel: false,
              label: "Paypal Email",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                },
                {
                  payload: {
                    pattern: "^[^@]+@[^@]+\\.[^@]+$"
                  },
                  statusMessage: "The email is invalid",
                  statusType: "error",
                  validationType: "pattern"
                }
              ]
            },
            inputStatus: "neutral",
            maxLines: 1,
            placeholder: "Paypal Email",
            value: "Pre-filled value"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "paypal email",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$paypalEmail",
                    label: "PayPal Input",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "textInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$paypalEmail",
      links: {
        self: "/v1/masonry-node/core$demo-form$paypalEmail?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$selectPaymentMethod",
          namespace: "default",
          type: "selectInput",
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: "selectInputConditional",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "Payment Method",
              label: "Payment Method",
              showOptionalFlag: false,
              tooltipContent: "Select the Payment Method",
              tooltipIcon: "statusInformationCircle",
              tooltipLabel: "Payment Method",
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            options: [
              {
                disabled: false,
                label: "Select the Payment Method",
                options: null,
                value: null
              },
              {
                disabled: false,
                label: "Credit Card",
                options: null,
                value: "credit"
              },
              {
                disabled: false,
                label: "Paypal",
                options: null,
                value: "paypal"
              },
              {
                disabled: false,
                label: "Bank Transfer",
                options: null,
                value: "transfer"
              }
            ]
          },
          actions: {
            onChange: {
              analytics: {
                event_name: EVENT_NAME.EVENT_FIRED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "select input conditional changed",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$selectPaymentMethod",
                    label: "Select input Conditional",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "selectInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {
                allNodes: [
                  "core$demo-form$cardNumber",
                  "core$demo-form$paypalEmail",
                  "core$demo-form$bankName",
                  "core$demo-form$accountNumber"
                ],
                showNodes: [
                  {
                    nodes: null,
                    value: null
                  },
                  {
                    nodes: [
                      "core$demo-form$cardNumber",
                      "core$demo-form$bankName"
                    ],
                    value: "credit"
                  },
                  {
                    nodes: ["core$demo-form$paypalEmail"],
                    value: "paypal"
                  },
                  {
                    nodes: [
                      "core$demo-form$bankName",
                      "core$demo-form$accountNumber"
                    ],
                    value: "transfer"
                  }
                ]
              },
              type: "toggleFormFieldVisibility"
            },
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  content: {
                    id: "demo-value",
                    name: "demo-value",
                    system: "demo-value"
                  },
                  detail: "select input conditional",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$selectPaymentMethod",
                    label: "Select input Conditional",
                    parent_label: "Stack with conditional examples",
                    parent_type: "verticalLayout",
                    type: "selectInput"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$selectPaymentMethod",
      links: {
        self: "/v1/masonry-node/core$demo-form$selectPaymentMethod?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormSelectInputDataProcessorBehavior",
          namespace: "default",
          type: "selectInput",
          properties: {
            disabled: false,
            formFieldProperties: {
              formFieldId: "expectedBehavior",
              formFieldType: "text",
              formId: "demo-form",
              hideLabel: false,
              hint: "If the validation passes the data processor will be invoked, but it's behavior is defined by that field",
              label: "Expected behavior of the data processor",
              showOptionalFlag: false,
              validationRules: [
                {
                  payload: {
                    required: true
                  },
                  statusMessage: "This field is required",
                  statusType: "error",
                  validationType: "required"
                }
              ]
            },
            options: [
              {
                disabled: false,
                label: "Success",
                options: null,
                value: "success"
              },
              {
                disabled: false,
                label: "Slow success",
                options: null,
                value: "slowSuccess"
              },
              {
                disabled: false,
                label: "Error: Processing",
                options: null,
                value: "errorProcessing"
              },
              {
                disabled: false,
                label: "Critical error: Processing (panic)",
                options: null,
                value: "panic"
              }
            ],
            value: "success"
          }
        }
      },
      id: "core$demo-form$demoFormSelectInputDataProcessorBehavior",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormSelectInputDataProcessorBehavior?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "core$demo-form$demoFormSubmitButton",
          namespace: "default",
          type: "button",
          properties: {
            label: "Submit",
            priority: "primary",
            size: "large",
            type: "submit"
          },
          actions: {
            onClick: {
              analytics: {
                event_name: EVENT_NAME.BUTTON_CLICKED,
                payload: {
                  detail: "submit button",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormSubmitButton",
                    label: "submitButton",
                    parent_label: "Form fields vertical layout",
                    parent_type: "verticalLayout",
                    type: "button"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {
                formId: "demo-form",
                formProcessorId: "masonrySample",
                onSuccessDeepLink: "/member/about-me?view=achievements"
              },
              type: "submitForm"
            }
          }
        }
      },
      id: "core$demo-form$demoFormSubmitButton",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormSubmitButton?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    },
    {
      attributes: {
        node: {
          locatorId: "demoForm-footer-LocatorId",
          namespace: "default",
          type: "imageBanner",
          properties: {
            image: "https://images.ctfassets.net/s9gs3yjnjpji/5hRVfLjPI7XvI87bUp90D/6585f41fe6c926190f942d3687c8c6f3/PBL-Logo-EN.png",
            imageAlignment: "center",
            imageAltText: "This is a imageBanner Powered by League"
          },
          actions: {
            onLoad: {
              analytics: {
                event_name: EVENT_NAME.SCREEN_LOADED,
                payload: {
                  detail: "footer",
                  impression_id: "90f54b79f72db21d15ea2309b259e8f4",
                  node: {
                    id: "core$demo-form$demoFormFooter",
                    label: "ImageBanner Card",
                    parent_label: "Demo form v2 root node",
                    parent_type: "verticalLayout",
                    type: "imageBanner"
                  },
                  product_area: "masonry",
                  screen_name: "demo-form",
                  sub_product_area: "form"
                }
              },
              namespace: "default",
              payload: {},
              type: "onLoad"
            }
          }
        }
      },
      id: "core$demo-form$demoFormFooter",
      links: {
        self: "/v1/masonry-node/core$demo-form$demoFormFooter?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
      },
      type: "node-data"
    }
  ],
  links: {
    self: "/v1/masonry-node/core$demo-form$root?masonryRequestId=90f54b79f72db21d15ea2309b259e8f4&test=test_param"
  }
};

// src/masonry-engine/masonry-root-node/get-async-node-and-format-to-masonry-node.ts
import {
  DEFAULT_NAMESPACE
} from "@leagueplatform/masonry-engine";
import {
  getModulePath,
  DEFAULT_ROUTES_MAP
} from "@leagueplatform/league-routes";
import { deserialise } from "kitsu-core";

// src/utils/get-masonry-node.ts
import { leagueFetch } from "@leagueplatform/league-fetch";

// src/utils/get-masonry-request-headers.ts
import { getConfig } from "@leagueplatform/config";
import { getCurrentBreakpoint } from "@leagueplatform/masonry-engine";
var getMasonryRequestHeaders = () => {
  const timeZone = typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone : "America/Toronto";
  return {
    "X-League-Client-Platform": "web",
    "X-League-Client-Time-Zone": timeZone,
    "X-League-Client-Version": getConfig().config.core.appVersion || "1.0.0",
    "X-League-Client-View-Size": getCurrentBreakpoint() || "desktop"
    // default to desktop if no clientViewSize is provided. A string value is required for this header as it cannot be undefined
  };
};

// src/utils/get-masonry-node.ts
var getMasonryNode = (_0) => __async(void 0, [_0], function* ({
  path,
  method,
  queryParams
}) {
  const url = new URL(path, window.location.origin);
  if (queryParams) {
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });
  }
  const completePath = url.href.replace(url.origin, "");
  const headers = getMasonryRequestHeaders();
  const response = yield leagueFetch(completePath, {
    method,
    allowUnauthenticated: true,
    headers
  });
  if (!response.ok) {
    throw new Error(`getMasonryNode error: ${response.status}`);
  }
  const responseJson = yield response.clone().json();
  return responseJson;
});

// src/masonry-engine/masonry-root-node/get-async-node-and-format-to-masonry-node.ts
var DEFAULT_ROUTES_MAP_ENTRIES = Object.entries(
  DEFAULT_ROUTES_MAP
);
var processUrl = (path) => {
  const match = DEFAULT_ROUTES_MAP_ENTRIES.find(
    (route) => path === route[1] || path.startsWith(`${route[1]}/`)
  );
  return match ? path.replace(new RegExp(`^${match[1]}`), getModulePath(match[0])) : path;
};
var getAsyncNode = (options) => __async(void 0, null, function* () {
  const data = yield getMasonryNode(options);
  return formatMasonryNode(data);
});
var formatSectionsToNode = (sectionsData) => sectionsData.reduce(
  (sections, activeSection) => {
    const sectionsList = sections;
    const {
      name: sectionName,
      nodes: { data: sectionData }
    } = activeSection;
    sectionsList[sectionName] = sectionData.map(
      (nodeInSection) => (
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        formatMasonryNode({
          data: nodeInSection,
          included: []
        })
      )
    );
    return sectionsList;
  },
  {}
);
var formatMasonryNode = (data) => {
  var _a;
  const formattedData = deserialise(data);
  const getNodeMeta = (_a = data.data.meta) == null ? void 0 : _a.getNode;
  const {
    node: { actions, properties, type, namespace, themeConfiguration },
    sections,
    id
  } = formattedData.data;
  if (actions) {
    Object.keys(actions).forEach((key) => {
      if (actions[key].type === "deeplink" && typeof actions[key].payload.url === "string") {
        actions[key].payload.url = processUrl(actions[key].payload.url);
      }
    });
  }
  const nodeValue = {
    id,
    type,
    properties: properties || {},
    namespace: namespace || DEFAULT_NAMESPACE,
    actions: actions || {},
    themeConfiguration,
    sections: sections ? formatSectionsToNode(sections.data) : {},
    getAsyncSelf: getNodeMeta ? (queryParams) => getAsyncNode({
      path: getNodeMeta.href,
      method: getNodeMeta.method,
      queryParams
    }) : void 0
  };
  return nodeValue;
};

// src/masonry-engine/masonry-ws-root-node/get-masonry-WS-root-node.ts
import { omit } from "lodash";
import { v4 as uuidv4 } from "uuid";

// src/utils/analytics-events-for-masonry-WS-driver.ts
import { trackAnalyticsEvent, EVENT_NAME as EVENT_NAME2 } from "@leagueplatform/analytics";

// src/constants/analytics-event-detail-mapping.ts
var DetailLargeVisualCardButtonClick = "text_with_large_image";
var DetailSmallVisualCardButtonClick = "text_with_small_image";
var DetailXSVisualCardButtonClick = "text_with_xsmall_image";
var DetailNotificationBannerButtonClick = "notification_banner";
var DetailNotificationBannerDismissClick = "notification_banner_dismiss_button";
var DetailNotificationCardButtonClick = "notification_card";
var DetailProgressRingButtonClick = "progress_ring";
var DetailProgressBarButtonClick = "progress_bar";
var DetailHeroBannerButtonClick = "welcome_banner_primary_button";
var DetailTextWithCTAButtonClick = "text_with_button_primary_button";
var Detail2UpCardWithCTAButtonClick = "2_up_card";
var DetailMetricCardButtonClick = "metric_card";
var DetailCarouselScrollRight = "scroll carousel right";
var DetailCarouselScrollLeft = "scroll carousel left";
var DetailCarouselHeaderButtonClick = "carousel_header_button";
var DetailCarouselHeaderSelectItem = "select item from carousel";
var DetailStackSelectItem = "select item from stack";

// src/utils/analytics-events-for-masonry-WS-driver.ts
var getDataForAnalyticsByWidgetType = (type, widgetAnalyticsData) => {
  switch (type) {
    case "xs_visual_card" /* XS_VISUAL_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading,
        text_sub_detail: widgetAnalyticsData.body,
        link_url: widgetAnalyticsData.linkUrl
      };
    case "progress_bar" /* PROGRESS_BAR */:
      return {
        text_detail: widgetAnalyticsData.eyebrow,
        current_progress: widgetAnalyticsData.currentText,
        maximum_progress: widgetAnalyticsData.suffixText,
        remaining_progress: widgetAnalyticsData.footerText,
        progress_percent: widgetAnalyticsData.progress,
        link_url: widgetAnalyticsData.action
      };
    case "progress_ring" /* PROGRESS_RING */:
      return {
        text_detail: widgetAnalyticsData.eyebrow,
        current_progress: widgetAnalyticsData.currentText,
        maximum_progress: widgetAnalyticsData.suffixText,
        progress_percent: widgetAnalyticsData.progress,
        link_url: widgetAnalyticsData.action
      };
    case "heroBanner" /* HERO_BANNER */:
      return {
        text_detail: widgetAnalyticsData.buttonLabel,
        link_url: widgetAnalyticsData.buttonAction
      };
    case "notification_card" /* NOTIFICATION_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading,
        text_sub_detail: widgetAnalyticsData.subheading,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
      };
    case "metricCard" /* METRIC_CARD */:
      return {
        text_detail: widgetAnalyticsData.heading
      };
    default:
      return {
        text_detail: widgetAnalyticsData.title,
        text_sub_detail: widgetAnalyticsData.description,
        link_url: widgetAnalyticsData.linkUrl
      };
  }
};
var getAnalyticsEventsForMasonryWSDriver = (widgetType, widgetAnalyticsData, appId, productArea, screenName, productIdentifier) => {
  const trackMasonryAnalytics = (event, widgetProperties) => () => trackAnalyticsEvent(event, __spreadValues({
    product_area: productArea,
    sub_product_area: appId,
    screen_name: screenName,
    product_identifier: productIdentifier
  }, widgetProperties));
  const getCarouselAnalyticEvents = () => {
    var _a, _b;
    const carouselRollup = {
      carousel_array: (_a = widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.items) == null ? void 0 : _a.map(
        (carouselItem) => carouselItem.title
      ),
      carousel_name: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.title,
      carousel_num_resources: (_b = widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.items) == null ? void 0 : _b.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onSelectItem: (item, index) => trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        sub_detail: item.title,
        text_detail: item.overline,
        carousel_index: index,
        link_url: item.linkUrl
      }, carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerLinkHint,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerLinkUrl
      }, carouselRollup))
    };
  };
  const getTwoUpCardAnalyticsEvent = () => ({
    onItemClick: ({ heading, body, actionLink }, index) => trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, {
      detail: Detail2UpCardWithCTAButtonClick,
      text_detail: heading,
      text_sub_detail: body,
      container_index: index,
      link_url: actionLink
    })()
  });
  const getNotificationBannerAnalyticsEvent = () => __spreadProps(__spreadValues({}, (widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url) && {
    onCardClick: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, {
      detail: DetailNotificationBannerButtonClick,
      text_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.heading,
      text_sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.body,
      link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
    })
  }), {
    onDismiss: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, {
      detail: DetailNotificationBannerDismissClick,
      text_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.heading,
      text_sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.body,
      link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.url
    })
  });
  const getStackAnalyticsEvents = () => {
    const stackRollup = {
      stack_array: widgetAnalyticsData.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      stack_name: widgetAnalyticsData.heading,
      stack_num_resources: widgetAnalyticsData.items.length
    };
    return {
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailStackSelectItem,
        stack_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(type, attributes)), stackRollup))()
    };
  };
  const getGenericCarouselAnalyticsEvents = () => {
    const carouselRollup = {
      carousel_array: widgetAnalyticsData.items.map(
        (stackItem) => {
          var _a, _b;
          return ((_a = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _a.title) || ((_b = stackItem == null ? void 0 : stackItem.attributes) == null ? void 0 : _b.heading);
        }
      ),
      carousel_name: widgetAnalyticsData.heading,
      carousel_num_resources: widgetAnalyticsData.items.length
    };
    return {
      onScrollLeft: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollLeft
      }, carouselRollup)),
      onScrollRight: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselScrollRight
      }, carouselRollup)),
      onItemClick: ({ attributes, type }, index) => trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues(__spreadValues({
        detail: DetailCarouselHeaderSelectItem,
        carousel_index: index,
        component_detail: type
      }, getDataForAnalyticsByWidgetType(type, attributes)), carouselRollup))(),
      onSelectHeader: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
        detail: DetailCarouselHeaderButtonClick,
        sub_detail: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerButtonLabel,
        link_url: widgetAnalyticsData == null ? void 0 : widgetAnalyticsData.headerButtonAction
      }, carouselRollup))
    };
  };
  const getCommonAnalyticsEvent = (widgetDetail) => () => ({
    onCardClick: trackMasonryAnalytics(EVENT_NAME2.BUTTON_CLICKED, __spreadValues({
      detail: widgetDetail
    }, getDataForAnalyticsByWidgetType(widgetType, widgetAnalyticsData)))
  });
  const getWidgetAnalyticsFromType = {
    /* ---- Complex Widgets ----*/
    ["carousel" /* CAROUSEL */]: getCarouselAnalyticEvents,
    ["2_up_card" /* TWO_UP_CARD */]: getTwoUpCardAnalyticsEvent,
    ["stack" /* STACK */]: getStackAnalyticsEvents,
    ["genericCarousel" /* GENERIC_CAROUSEL */]: getGenericCarouselAnalyticsEvents,
    /* ---- Simple Widgets ----*/
    ["heroBanner" /* HERO_BANNER */]: getCommonAnalyticsEvent(
      DetailHeroBannerButtonClick
    ),
    ["progress_bar" /* PROGRESS_BAR */]: getCommonAnalyticsEvent(
      DetailProgressBarButtonClick
    ),
    ["progress_ring" /* PROGRESS_RING */]: getCommonAnalyticsEvent(
      DetailProgressRingButtonClick
    ),
    ["xs_visual_card" /* XS_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailXSVisualCardButtonClick
    ),
    ["notification_banner" /* NOTIFICATION_BANNER */]: getNotificationBannerAnalyticsEvent,
    ["notification_card" /* NOTIFICATION_CARD */]: getCommonAnalyticsEvent(
      DetailNotificationCardButtonClick
    ),
    ["text_with_button" /* TEXT_WITH_CTA_CARD */]: getCommonAnalyticsEvent(
      DetailTextWithCTAButtonClick
    ),
    ["text_with_large_image" /* LARGE_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailLargeVisualCardButtonClick
    ),
    ["text_with_small_image" /* SMALL_VISUAL_CARD */]: getCommonAnalyticsEvent(
      DetailSmallVisualCardButtonClick
    ),
    ["metricCard" /* METRIC_CARD */]: getCommonAnalyticsEvent(
      DetailMetricCardButtonClick
    )
  };
  const widgetAnalyticsEventsFn = getWidgetAnalyticsFromType[widgetType];
  return widgetAnalyticsEventsFn ? widgetAnalyticsEventsFn() : {};
};

// src/utils/format-object-keys-to-camel-case.ts
var convertToCamelCase = (str) => str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());
var formatObjectKeysToCamelCase = (obj = {}) => Object.keys(obj).reduce((finalObj, key) => {
  finalObj[convertToCamelCase(key)] = obj[key];
  return finalObj;
}, {});

// src/masonry-engine/masonry-ws-root-node/get-masonry-WS-root-node.ts
var formatCarouselOrStackResponse = (widget, analyticsProperties) => {
  var _a;
  const { id, type, attributes, traits } = widget;
  const { onItemClick } = analyticsProperties;
  return {
    id,
    type,
    properties: __spreadValues(__spreadProps(__spreadValues({}, omit(attributes, "items")), {
      traits
    }), analyticsProperties),
    sections: {
      items: (_a = attributes == null ? void 0 : attributes.items) == null ? void 0 : _a.map(
        (slot, index) => ({
          id: uuidv4(),
          type: slot.type,
          namespace: "default",
          properties: __spreadProps(__spreadValues({}, formatObjectKeysToCamelCase(slot.attributes)), {
            traits: slot.traits,
            // Each child of generic carousel/stack expects onCardClick instead of onItemClick callback event name
            onCardClick: () => onItemClick(widget, index)
          })
        })
      )
    }
  };
};
var getDismissibleLink = (links) => links == null ? void 0 : links.find((link) => link.rel === "dismiss");
var MASONRY_WS_API_VERSION = 2;
var getMasonryWSRootNode = ({
  appId,
  productArea,
  screenName,
  apiParams
}) => ({
  id: appId,
  type: "containerSpinner",
  properties: {},
  sections: {},
  namespace: "default",
  getAsyncSelf: () => __async(void 0, null, function* () {
    const containerData = yield getWidgetContainer(
      appId,
      MASONRY_WS_API_VERSION,
      apiParams
    );
    return {
      id: appId,
      /**
       * As all widgets in a container are shown vertically, thus setting
       * node type of Masonry WS container to a "stack" with orientation trait
       * set to "vertical".
       */
      type: "stack",
      properties: {
        traits: {
          mobile: {
            orientation: "vertical" /* VERTICAL */
          },
          tablet: {
            orientation: "vertical" /* VERTICAL */
          },
          laptop: {
            orientation: "vertical" /* VERTICAL */
          },
          desktop: {
            orientation: "vertical" /* VERTICAL */
          }
        }
      },
      namespace: "default",
      sections: {
        items: containerData.widgets.map((widget) => ({
          id: widget.id,
          type: widget.type || "loadingSmall" /* SMALL */,
          properties: {},
          sections: {},
          getAsyncSelf: () => __async(void 0, null, function* () {
            var _a;
            const linkDetails = widget.links.find(({ rel }) => rel === "data");
            const widgetResponse = yield getWidgetData(
              normalizeParams({ params: linkDetails == null ? void 0 : linkDetails.params }),
              MASONRY_WS_API_VERSION,
              widget.id
            );
            const analyticsProperties = getAnalyticsEventsForMasonryWSDriver(
              widgetResponse.type,
              widgetResponse.attributes,
              appId,
              productArea,
              screenName,
              widgetResponse.product_identifier
            );
            if (widgetResponse.type === "genericCarousel" || widgetResponse.type === "stack") {
              return formatCarouselOrStackResponse(
                widgetResponse,
                analyticsProperties
              );
            }
            return {
              id: widget.id,
              sections: {},
              namespace: widgetResponse.module,
              type: widgetResponse.type,
              properties: __spreadValues(__spreadProps(__spreadValues({}, widgetResponse.attributes ? formatObjectKeysToCamelCase(widgetResponse.attributes) : {}), {
                items: ((_a = widgetResponse.attributes) == null ? void 0 : _a.items) ? widgetResponse.attributes.items.map(
                  (item) => formatObjectKeysToCamelCase(item)
                ) : void 0,
                traits: widgetResponse.traits,
                dismissibleLink: getDismissibleLink(widgetResponse.links)
              }), analyticsProperties)
            };
          })
        }))
      }
    };
  })
});

// src/masonry-engine/masonry-root-node/get-masonry-root-node.ts
import {
  DEFAULT_NAMESPACE as DEFAULT_NAMESPACE2
} from "@leagueplatform/masonry-engine";

// src/constants/masonry-node-api.ts
var GET_MASONRY_NODE_ENDPOINT = "/v1/masonry-node/";
var MASONRY_NODE_DISMISS_ENDPOINT = "v1/masonry-node/dismiss";

// src/masonry-engine/masonry-root-node/get-masonry-root-node.ts
var getMasonryRootNode = ({
  rootNodeId
}) => ({
  id: rootNodeId,
  type: "containerSpinner",
  // Replace this with spinner renderer
  properties: {},
  sections: {},
  namespace: DEFAULT_NAMESPACE2,
  getAsyncSelf: (queryParams) => __async(void 0, null, function* () {
    return getAsyncNode({
      path: `${GET_MASONRY_NODE_ENDPOINT}${rootNodeId}`,
      method: "GET",
      queryParams
    });
  })
});

// src/utils/post-masonry-node-dismiss.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
var postMasonryNodeDismiss = (_0) => __async(void 0, [_0], function* ({
  nodeIds,
  id
}) {
  const response = yield leagueFetch2(MASONRY_NODE_DISMISS_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      data: {
        id,
        type: "dismissed",
        attributes: {
          nodeIds
        }
      }
    })
  });
  if (response.ok) {
    return true;
  }
  throw new Error(`Masonry Dismiss Action Error:${response.status}`);
});

// src/utils/delete-masonry-node-dismiss.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var deleteMasonryNodeDismiss = (_0) => __async(void 0, [_0], function* ({
  nodeIds,
  id
}) {
  const response = yield leagueFetch3(MASONRY_NODE_DISMISS_ENDPOINT, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      data: {
        id,
        type: "un-dismissed",
        attributes: {
          nodeIds
        }
      }
    })
  });
  if (response.ok) {
    return true;
  }
  throw new Error(`Masonry Undismiss Action Error:${response.status}`);
});

// src/utils/post-masonry-form.ts
import { leagueFetch as leagueFetch4 } from "@leagueplatform/league-fetch";

// src/constants/masonry-form-api.ts
var POST_MASONRY_FORM = "/v1/masonry-form";

// src/utils/format-form-fields.ts
var formatFormFields = (fieldNodes) => fieldNodes.map(({ nodeId, value, formFieldProperties: { formFieldId } }) => ({
  nodeId,
  value,
  formFieldId
}));

// src/utils/post-masonry-form.ts
var postMasonryForm = (_0) => __async(void 0, [_0], function* ({
  formId,
  formProcessorId,
  fieldNodes,
  getNodeQueryParams
}) {
  const url = `${POST_MASONRY_FORM}/${formId}`;
  const body = {
    data: {
      type: "submit-form-request",
      attributes: {
        fields: formatFormFields(fieldNodes),
        formProcessorId,
        getNodeQueryParams
      }
    }
  };
  const headers = getMasonryRequestHeaders();
  const response = yield leagueFetch4(url, {
    method: "POST",
    headers,
    allowUnauthenticated: true,
    body: JSON.stringify(body)
  });
  if (!response.ok) {
    const error = yield response.json();
    throw new Error(
      `Error posting masonry form: ${error.message || "Unknown error"}`
    );
  }
  const responseJson = yield response.clone().json();
  return responseJson.data;
});
export {
  GET_WIDGET_CONTAINER2 as GET_WIDGET_CONTAINER,
  GET_WIDGET_DATA2 as GET_WIDGET_DATA,
  LoaderType,
  Orientation,
  SupportedMedia,
  WidgetType,
  deleteMasonryNodeDismiss,
  formatMasonryNode,
  getMasonryRootNode,
  getMasonryWSRootNode,
  getObservabilityContext,
  getWidgetContainerMock,
  getWidgetContainerV2Mock,
  mockMasonryFormsNode,
  postMasonryForm,
  postMasonryNodeDismiss,
  useGeneratePDFReport,
  useGetWidgetContainer,
  useGetWidgetData,
  useInvalidateContainerRequest,
  usePostDismissWidget
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-api'] = window.leagueSDKsPresent['@leagueplatform/masonry-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/masonry-api'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/masonry-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/masonry-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map